import styled, { css } from 'styled-components';
import { elevation } from '../Styles/Utils/elevation.js';

const Input = styled.input.withConfig({
    displayName: "styles__Input",
    componentId: "sc-31185789-0"
})`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    appearance: none;
    cursor: pointer;
    z-index: 1;
`;
const RadioButton = styled.button.withConfig({
    displayName: "styles__RadioButton",
    componentId: "sc-31185789-1"
})`
    position: relative;
    max-width: 100%;
    flex: 0 0 auto;
    height: 40px;
    padding: 6px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 8px;
    transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.3s;
    -webkit-tap-highlight-color: transparent;
    outline: 0;
    border-style: solid;
    border-width: 2px;
    border-color: ${(props)=>props.theme.colors["Level 1"]};
    color: ${(props)=>props.theme.colors["Level 5"]};
    background-color: ${(props)=>props.theme.colors.ElementBackground};

    :hover,
    :focus {
        border-color: transparent;
        ${elevation(2, true)}
    }

    ${(props)=>props.isChecked && css`
            color: white;
            border-color: transparent;
            background-color: ${props.theme.colors.secondary};
        `}
`;
const Label = styled.label.withConfig({
    displayName: "styles__Label",
    componentId: "sc-31185789-2"
})`
    display: flex;
    justify-content: center;
    align-items: center;
    color: inherit;
    overflow: hidden;
`;
const Text = styled.span.withConfig({
    displayName: "styles__Text",
    componentId: "sc-31185789-3"
})`
    ${(props)=>props.theme.typography.Paragraph}
    color: inherit;
    text-align: center;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
const GroupContainer = styled.div.withConfig({
    displayName: "styles__GroupContainer",
    componentId: "sc-31185789-4"
})`
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;

    margin-right: -8px;
    margin-bottom: -8px;
`;

export { GroupContainer, Input, Label, RadioButton, Text };
